import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Mail, ArrowUpRight } from "lucide-react";
import Seo, { BREADCRUMB_JSONLD, CONTACT_PAGE_JSONLD } from "@/components/Seo";

const SUPPORT_EMAIL = "getjeweldesigns@gmail.com";

export default function Contact() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="max-w-[1000px] mx-auto px-4 md:px-8 py-12 md:py-20">
      <Seo
        title="Contact"
        description="Talk to the GetJewelDesigns studio. Email us about a quotation, order, refund or your data — we typically reply within one business day."
        path="/contact"
        jsonLd={[CONTACT_PAGE_JSONLD, BREADCRUMB_JSONLD([{ name: "Home", path: "/" }, { name: "Contact", path: "/contact" }])]}
      />
      <div className="text-xs uppercase tracking-[0.3em] text-primary mb-4">Contact</div>
      <h1 className="font-serif text-4xl md:text-6xl mb-4 tracking-tight">Talk to the studio.</h1>
      <p className="text-muted-foreground text-lg leading-relaxed max-w-2xl mb-4">
        The fastest way to reach us is by email — we typically reply within one business day. If your
        question is about an existing project, please include your order or quotation reference.
      </p>
      <div className="border hairline p-7 mb-12 bg-background">
        <Mail className="h-5 w-5 text-primary mb-4" strokeWidth={1} />
        <div className="font-serif text-xl mb-1">Support &amp; all enquiries</div>
        <p className="text-sm text-muted-foreground mb-4">
          Questions about a quotation, order, refund or your data — email us and we'll reply within one
          business day.
        </p>
        <a href={`mailto:${SUPPORT_EMAIL}`} className="text-sm text-primary hover:underline underline-offset-4 break-all">{SUPPORT_EMAIL}</a>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="border hairline p-8">
          <h2 className="font-serif text-2xl mb-3">Studio</h2>
          <p className="text-muted-foreground text-sm leading-relaxed">
            GetJewelDesigns<br />
            Surat, Gujarat, India
          </p>
          <p className="text-muted-foreground text-sm leading-relaxed mt-4">
            Hours · Monday–Saturday, 10:00 AM – 7:00 PM IST
          </p>
        </div>
        <div className="border hairline p-8">
          <h2 className="font-serif text-2xl mb-3">Looking to design with us?</h2>
          <p className="text-muted-foreground text-sm leading-relaxed mb-5">
            We're always open to meeting talented jewellery CAD specialists. Applications are reviewed on
            craft and confidentiality.
          </p>
          <Link to="/freelancer/apply" className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-primary hover:underline underline-offset-4">
            Apply as a designer <ArrowUpRight className="h-4 w-4" strokeWidth={1} />
          </Link>
        </div>
      </div>
    </div>
  );
}
